import {connect} from 'react-redux';

import _ from 'topmeteo/utils/i18n';

import {Resolutions} from './ResolutionItem';

const Label = _('Resolution');

const Prefix = 'resolution';
const Delimiter = '$';

export const isResolution = value => value.startsWith(Prefix);
export const getResolution = value => {
    const [, resolution] = value.split(Delimiter);

    return +resolution;
};
export const getValue = resolution => [Prefix, resolution].join(Delimiter);

const ResolutionOptGroup = () => (
    <optgroup label={Label}>
        {Resolutions.map(({value, label}) => (
            <option key={value} value={getValue(value)}>
                {label}
            </option>
        ))}
    </optgroup>
);

const mapStateToProps = state => ({
    selected: state.resolution,
});

export default connect(mapStateToProps)(ResolutionOptGroup);
